import { defineDirective } from '~/scripts/utils/alpine'

/**
 * x-underline directive
 * @example add a animated underline to an element on mouse enter and leave
 * <a x-underline>Link</a>
 */
export default defineDirective((element) => {
  element.addEventListener('pointerenter', (event) => {
    if (event.pointerType !== 'mouse') return
    element.classList.remove('underline-out')
    element.classList.add('underline-in')
  })
  element.addEventListener('pointerleave', (event) => {
    if (event.pointerType !== 'mouse') return
    element.classList.remove('underline-in')
    element.classList.add('underline-out')
  })
})
